export const AWAY_CALENDAR_NEW_LABEL = 'New';

/**
 * Whether the New badge shows. `shouldShowCallout` is false while the callouts
 * query loads and once the expert has first opened the date sheet, so the
 * badge fails closed.
 */
export function canShowAwayCalendarBadge({
  isEligible,
  shouldShowCallout,
}: {
  /** An expert who can see the calendar, with their account loaded. */
  isEligible: boolean;
  shouldShowCallout: boolean;
}): boolean {
  return isEligible && shouldShowCallout;
}

/** The row's spoken label, which says "New" so a screen reader announces the badge. */
export function getAvailabilityRowLabel({
  isNew,
  subtitle,
}: {
  isNew: boolean;
  subtitle: string;
}): string {
  return isNew
    ? `Availability, ${AWAY_CALENDAR_NEW_LABEL}, ${subtitle}`
    : `Availability, ${subtitle}`;
}
